import { Component, OnInit } from '@angular/core';
import { UsersListComponent } from '../../shared/users-list/users-list.component';

@Component({
  selector: 'app-users-home',
  templateUrl: './users-home.component.html',
  styleUrls: ['./users-home.component.scss']
})
export class UsersHomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
